module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/trending-up-cm.ae6adf72.svg";